<div class="page-wrapper">
  <div class="authentication-box">
    <div class="container">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6 p-0">
          <div class="card tab2-card">
            <div class="card-body">
              <div class="row"><img class="center-item" src="../../../../assets/images/register-logo.png" alt=""></div>
              <br>
              <div class="row">
                <h5 class="center-item"><i class="icon-unlock mr-2"></i> Creare cont POSF</h5>
              </div>
              <!--<div class="row justify-content-md-center">
                <div class="center-item" style=" align-content: center; text-align: center">
                  <div placement="bottom" class="d-inline-block dropdown alert alert-warning"
                    style=" align-content: center; text-align: center; ">
                    Până la încărcarea şi validarea tuturor datelor de către operatorii de rețea și furnizori, clienții
                    finali au acces în POSF la următoarele funcții:
                    Înregistrare/Autentificare utilizator, Completare date de identificare, Asociere locuri de consum și
                    vizualizarea datelor aferente contractelor de furnizare încărcate în POSF, Vizualizare oferte tip în
                    comparatorul de oferte.
                  </div>
                </div>
              </div>-->
              <hr>
              <form [formGroup]="registrationForm" class="form-horizontal needs-validation" novalidate>
                <!--<div class="form-group">
                  <select class="form-control same-input-font-size" name="role" formControlName="role" id="role">
                    <option class="form-control" value="" disabled selected hidden>Alegeți tipul de utilizator</option>
                    <option value="final_client">Client Final</option>
                    <option value="supplier">Furnizor</option>
                    <option value="operator">Operator Retea</option>
                  </select>
                  <div *ngIf="form['role'].errors && (registrationForm.dirty || registrationForm.touched)"
                    class="text text-danger">
                    Alegeți tipul de utilizator
                  </div>
                </div>-->
                <div class="form-group">
                  <input required name="email" type="email" class="form-control" placeholder="E-mail"
                    formControlName="email" id="email">
                  <div *ngIf="form['email'].errors && (registrationForm.dirty || registrationForm.touched)"
                    class="text text-danger">
                    Email invalid
                  </div>
                </div>
                <!--<div class="form-group center-item">
                  <button class="btn btn-primary-gradien lowercase" type="button" (click)="sendOTP()"
                    [disabled]="form['email'].errors || form['role'].errors && (registrationForm.dirty || registrationForm.touched)">
                    Trimite cod de
                    verificare
                  </button>
                </div>
                <div class="form-group">
                  <input required="" formControlName="otp" type="text" class="form-control"
                    placeholder="Cod de verificare" id="otp">
                  <div *ngIf="form['otp'].errors &&  (registrationForm.dirty || registrationForm.touched)"
                    class="text text-danger">
                    Vă rugăm să introduceți codul OTP primit pe email
                  </div>
                </div>
                <div class="form-group center-item">
                  <button class="btn btn-primary-gradien button-margin-10 lowercase"
                    [disabled]="form['otp'].errors || form['email'].errors" (click)="checkOTP()">
                    Verificare cod
                  </button>
                  <button class="btn btn-primary-gradien button-margin-10 lowercase"
                    [disabled]="form['email'].errors || form['role'].errors && (registrationForm.dirty || registrationForm.touched)"
                    (click)="resendOTP()">
                    Trimitere cod nou
                  </button>
                </div>-->
                <div class="form-group">
                  <input required="" formControlName="password" type="password" class="form-control"
                    placeholder="Parola" id="password">
                  <div *ngIf="form['password'].errors && (registrationForm.dirty || registrationForm.touched)"
                    class="text text-danger">
                    Parola trebuie sa contina minim 6 caractere, cel puțin o literă mare, o literă mică, un număr și un
                    caracter special
                  </div>
                </div>
                <div class="form-group">
                  <input required="" formControlName="passwordConfirm"
                    [type]="shouldHidePasswordConfirm() ? 'password' : 'text'" class="form-control"
                    placeholder="Confirmare parola" id="passwordConfirm">
                  <div
                    *ngIf="registrationForm.errors?.['notMatched']  && (registrationForm.dirty || registrationForm.touched)"
                    class="text text-danger">
                    Parolele nu coincid
                  </div>
                </div>
                <div class="form-terms">
                  <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" class="custom-control-input" formControlName="termsAndConditions"
                      id="termsAndConditions">
                    <label class="custom-control-label" for="termsAndConditions"><span>Am citit și sunt de acord cu <a
                          href="../../../../assets/pdf/Termenii și Condițiile de utilizare a POSF.pdf"
                          target="_blank">Termenii și Condițiile de utilizare</a> a acestei
                        platforme</span><span>*</span></label>
                    <div *ngIf="form['termsAndConditions'].errors &&  registrationForm.touched"
                      class="text text-danger">
                      Vă rugăm să indicați că ați citit și sunteți de acord cu Termenii și Condițiile
                    </div>
                  </div>
                  <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" class="custom-control-input" id="gdpr" formControlName="gdpr">
                    <label class="custom-control-label" for="gdpr"><span>Am citit și sunt de acord cu <a
                          href="../../../../assets/pdf/Termenii de prelucrare a Datelor cu Caracter Personal.pdf"
                          target="_blank">Termenii de prelucrare a Datelor cu Caracter
                          Personal</a></span><span>*</span></label>
                    <div *ngIf="form['gdpr'].errors &&  registrationForm.touched" class="text text-danger">
                      Vă rugăm să indicați că ați citit și sunteți de acord cu Termenii de prelucrare a Datelor cu
                      Caracter Personal
                    </div>
                  </div>
                </div>
                <br>
                <div class="form-group center-item">
                  <button class="btn btn-primary-gradien button-margin-10 lowercase"
                    [disabled]="registrationForm.invalid" (click)="register()">
                    Creare cont
                  </button>
                  <a (click)="goBack()" class="btn btn-danger-gradien back-btn button-margin-10 lowercase">
                    <app-public-feather-icons [icon]="'arrow-left'"></app-public-feather-icons>
                    Inapoi
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
